/*
  Bridge lead form.
*/

$(document).ready(function () {
  $('.bridge-lead-form').each(function () {
    var $form = $(this);

    const API_BASE = 'https://forge-tools.dimunation.com/';
    const ENDPOINT = API_BASE +
      ($form.data('lead-type') === 'coupon' ? 'coupon.php' : 'quote.php');

    const CAMPAIGN_ID = $form.data('campaign-id') || '';
    const TURNSTILE_KEY = $form.data('turnstile-key') || '';

    const THANKYOU_URL = $form.data('thankyou-url') ||
      (ENDPOINT === API_BASE + 'coupon.php'
        ? '/pages/thank-you-promotion'
        : '/pages/thank-you-request-a-quote');

    const SUBMIT_LABEL = $form.find('button[type="submit"]').text().trim() || 'Submit';

    let turnstileWidgetId = null;


    function initTurnstile() {
      if (!TURNSTILE_KEY || turnstileWidgetId !== null) return;
      const holder = $form.find('.bridge-lead-form-turnstile').get(0);
      if (!holder || typeof window.turnstile === 'undefined') return;

      turnstileWidgetId = window.turnstile.render(holder, {
        sitekey: TURNSTILE_KEY,
        'refresh-expired': 'auto'
      });
    }


    function resetTurnstile() {
      if (turnstileWidgetId === null || typeof window.turnstile === 'undefined') return;
      window.turnstile.reset(turnstileWidgetId);
    }

    function turnstileToken() {
      return $form.find('[name="cf-turnstile-response"]').val() || '';
    }

    if (TURNSTILE_KEY) {
      if (typeof window.turnstile !== 'undefined') {
        initTurnstile();
      } else {
        const previousCallback = window.onloadTurnstileCallback;
        window.onloadTurnstileCallback = function () {
          if (typeof previousCallback === 'function') previousCallback();
          initTurnstile();
        };
        $(window).on('load', initTurnstile);
      }
    }

    const renderedAt = Date.now();

    function debounce(func, wait) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), wait);
      };
    }

    function isValidUSZip(zip) {
      const usRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
      return usRegex.test(zip);
    }

    // Dealer locator codes. NOT the Salesforce brand short-codes
    const FUEL_DEALER_BRAND_CODES = {
      Wood:     ['FWC', 'FWP', 'FWU'],
      Pellet:   ['FPC', 'FPH', 'FPQ', 'FUH', 'FUQ'],
      Gas:      ['FGC', 'FGP', 'FGU'],
      Electric: ['FEC', 'FEP', 'FEU']
    };

    function getSelectedFuel() {
      return $form.find('input[name="fuel"]:checked').val() || '';
    }

    function getSelectedBrands() {
      return FUEL_DEALER_BRAND_CODES[getSelectedFuel()] || [];
    }

    function resetDealerSelect(dealerSelect) {
      dealerSelect.empty();
      dealerSelect.append(`<option value="">Select a Dealer</option>`);
      dealerSelect.append(`<option value="null">Not Sure - Connect me with a dealer</option>`);
    }

    let dealerQueryKey = null;

    // Only queries when the ZIP is valid and a fuel is chosen.
    function updateDealersList() {
      const postalCode = $form.find('#zipcode-bridge').val().trim();
      const selectedBrands = getSelectedBrands();

      const isZipValid = isValidUSZip(postalCode);
      const hasBrands = selectedBrands.length > 0;

      const dealerSelect = $form.find('#dealer-bridge');

      if (!isZipValid || !hasBrands) {
        // Nothing to query
        if (dealerQueryKey !== null) resetDealerSelect(dealerSelect);
        dealerQueryKey = null;
        return;
      }

      const brandFilter = selectedBrands.join(',');
      const queryKey = postalCode + '|' + brandFilter;

      // Already showing this exact result
      if (queryKey === dealerQueryKey) return;
      dealerQueryKey = queryKey;

      resetDealerSelect(dealerSelect);

      const dealerRequestBody = {
        Zip: postalCode,
        BusinessUnit: "stove",
        Country: "US",
        BrandFilter: brandFilter,
        DealerType: "Consumer",
        PrimarySort: "award",
        RuleSet: "custom",
        CustomRadiantType: "radius",
        CustomRadiantValue: "100"
      };

      $.ajax({
        url: "https://data.hearthnhome.com/api/Locator/Search",
        //url: "https://staging-data.hearthnhome.com/api/Locator/Search",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(dealerRequestBody),
        success: function (response) {
          if (queryKey !== dealerQueryKey) return;

          resetDealerSelect(dealerSelect);

          if (response.Success && response.Dealers && response.Dealers.length > 0) {
            response.Dealers.forEach(dealer => {
              dealerSelect.append(`<option value="${dealer.DealerID}" title="${dealer.Name}">${dealer.Name} | ${dealer.Distance} miles</option>`);
            });
          } else {
            dealerSelect.append(`<option value="">No dealers found</option>`);
          }
        },
        error: function () {
          if (queryKey !== dealerQueryKey) return;
          // Clear the key so the same ZIP can be retried.
          dealerQueryKey = null;
          alert("Could not fetch dealers. Please try again later.");
        }
      });
    }

    const debouncedUpdateDealersList = debounce(updateDealersList, 300);

    $form.find('#zipcode-bridge').on('input', debouncedUpdateDealersList);
    $form.find('input[name="fuel"]').on('change', debouncedUpdateDealersList);


    function syncPhoneRequirement() {
      const wantsPhone = $form.find('input[name="contact"]:checked').val() === 'Phone';
      $form.find('#phone-bridge').prop('required', wantsPhone);
      $form.find('.phone-required-mark').prop('hidden', !wantsPhone);
    }

    $form.find('input[name="contact"]').on('change', syncPhoneRequirement);
    syncPhoneRequirement();

    $form.on('submit', function (e) {
      e.preventDefault();

      const submitBtn = $form.find('button[type="submit"]');

      if (submitBtn.prop('disabled')) return;
      submitBtn.prop('disabled', true);
      submitBtn.text('Submitting...');

      function releaseButton() {
        submitBtn.prop('disabled', false);
        submitBtn.text(SUBMIT_LABEL);
        resetTurnstile();
      }

      let firstName = $form.find('#firstname-bridge').val();
      let lastName = $form.find('#lastname-bridge').val();
      let postalCode = $form.find('#zipcode-bridge').val();
      let email = $form.find('#email-bridge').val();
      let phone = $form.find('#phone-bridge').val();
      let contactMethod = $form.find('input[name="contact"]:checked').val();
      let fuel = getSelectedFuel();
      let dealerID = $form.find('#dealer-bridge').val();
      let comments = $form.find('#comments-bridge').val();

      let usRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
      if (!(postalCode.length <= 10 && usRegex.test(postalCode))) {
        $form.find('#zipcode-bridge').val('');
        alert("Invalid zip or postal code");
        releaseButton();
        return;
      }

      if (fuel === "") {
        alert("Please select a fuel type.");
        releaseButton();
        return;
      }

      if (!contactMethod) {
        alert("Please choose how you'd like to be contacted.");
        releaseButton();
        return;
      }

      if (contactMethod === "Phone" && phone.trim() === "") {
        alert("Please enter a phone number, or choose Email instead.");
        $form.find('#phone-bridge').trigger('focus');
        releaseButton();
        return;
      }

      let formData = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        postalCode: postalCode,
        fuel: fuel,
        preferredConsultationMethod: contactMethod,
        comments: comments,
        dealerId: dealerID,
        campaignId: CAMPAIGN_ID,
        rawUrl: window.location.href,
        turnstileToken: turnstileToken(),
        _hp: $form.find('input[name="_hp"]').val(),
        _elapsed: Date.now() - renderedAt
      };

      let formJSON = JSON.stringify(formData);

      if (firstName !== "" && lastName !== "" && email !== "" && postalCode !== "" && fuel !== "") {
        $.ajax({
          url: ENDPOINT,
          type: "POST",
          dataType: "json",
          data: formJSON,
          contentType: "application/json",
          success: function (response) {
            if (response && response.ok === false) {
              console.error('[bridge] rejected', response);
              releaseButton();
              return;
            }
            window.location.href = THANKYOU_URL;
          },
          error: function (xhr) {
            console.error('[bridge] submit failed', xhr.status, xhr.responseJSON || xhr.responseText);
            releaseButton();
          }
        });
      } else {
        console.log("Please fill mandatory fields");
        releaseButton();
      }
    });

  });
});
